import { Headers } from '@egw/components'
import { InvestmentsAccountDetail } from '@egw/features-investment'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsDetailsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investments_account_detail.title')} />
      <InvestmentsAccountDetail />
    </Layout>
  )
}
